export default __webpack_public_path__ + "static/media/ParCommandLogo.59fa6c98.png";